import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Rx';
import { Item } from './item.model';
import { AuthServerProvider, ResponseWrapper, createRequestOption } from '../../shared';
import { API } from '../../shared/constants/api.constants';
import * as $ from 'jquery';
@Injectable()
export class ItemService {
    private resourceUrl = API.host + 'InvoicePortal/get-client-info';
    private resourceUpdateUrl = API.host + 'InvoicePortal/update-client-info';
    constructor(
        private http: Http,
        private httpClient: HttpClient,
        private authServerProvider: AuthServerProvider
    ) { }

    update(item: Item): Observable<Item> {
    const copy = this.convert(item);
    return this.httpClient.post<any>(`${this.resourceUpdateUrl}/${item.id}`, copy).pipe(
        map((res: any) => {
            if (!res || !res.data) {
                throw 'Invalid Code';
            }
            return res.data;
        })
    );
}

    find(id: number): Observable<Item> {
    return this.httpClient.get<any>(`${this.resourceUrl}/${id}`).pipe(
        map((res: any) => {
            if (!res || !res.data) {
                throw 'Invalid Code';
            }
            return res.data;
        })
    );
}
    // query(req?: any): Observable<ResponseWrapper> {
    //     const options = createRequestOption(req);
    //     return this.http.get(this.resourceUrl, options)
    //         .map((res: Response) => this.convertResponse(res));
    // }

    // private convertResponse(res: Response): ResponseWrapper {
    //     if (!res || !res.json) {
    //         throw 'Invalid Code';
    //     }

    //     const jsonResponse = res.json().data;
    //     return new ResponseWrapper(res.headers, jsonResponse, res.status);
    // }

    private convert(item: Item): Item {
        const copy: Item = Object.assign({}, item);
        return copy;
    }
}
